import PropTypes from "prop-types";

// Third party
import { v4 as uuidv4 } from "uuid";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// MUI
import { GridRowModes } from "@mui/x-data-grid-premium";

// Icons
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import AddCircleRounded from "@mui/icons-material/AddCircleRounded";

function AddAction(props) {
	const { disabled, defaultRowValues, setRowModesModel, setRows, onAddAction } = props;

	const onClickHandler = () => {
		if (!!setRows && !!setRowModesModel) {
			// define the new row
			const id = uuidv4();
			const newRow = {
				_id: id,
				isNew: true,
				...defaultRowValues,
			};

			// add a new row
			setRows((oldRows) => [...oldRows, newRow]);

			// set new row to edit mode
			setRowModesModel((oldModel) => ({
				...oldModel,
				[id]: { mode: GridRowModes.Edit },
			}));

			onAddAction?.(newRow.id);
		}

		onAddAction?.();
	};

	return (
		<SimpleIconButton
			onClick={onClickHandler}
			icon={<AddCircleOutlineRoundedIcon />}
			iconHover={<AddCircleRounded />}
			disabled={disabled}
		/>
	);
}
AddAction.propTypes = {
	disabled: PropTypes.bool,
	defaultRowValues: PropTypes.object,
	setRowModesModel: PropTypes.func,
	setRows: PropTypes.func,
	onAddAction: PropTypes.func,
};

export default AddAction;
